// import { keysOfIn18 } from '@/lang'
const UrlData = {
  pc: [
    'ibu-icas-uat.sit.sf-express.com',
    'ibu-icas.sf-express.com',
    'icas.sit.kexsystem.com.my',
    'icas.my.kex-express.com',
    'icas.th.kerryexpress.com',
    'icas-uat.sf.global',
    'icas.sf.global',
    'icas-cbsg-uat.sf.global',
    'ibu-icas-cbsg-web-uat.sf.global',
    'icas.sit.kexsystem.com.th',
    'icas.th.kex-express.com',
    'icas-os-uat.sf.global',
    'icas-os.sf.global',
    'icas-id.sit.sf-express.com',
    'icas-id.sf-express.com',
    'icas-uat.th.kex-express.com'
  ],
  mobile: [
    'ibu-icas-web.sit.sf-express.com',
    'ibu-icas-web.sf-express.com',
    'icas-h5.sit.kexsystem.com.my',
    'icas-h5.my.kex-express.com',
    'icas-h5.my.kex-express.com',
    'ibu-icas-web-uat.sf.global',
    'ibu-icas-web.sf.global',
    'icas-cbsg.sf.global',
    'ibu-icas-cbsg-web.sf.global',
    'icas-h5.sit.kexsystem.com.my',
    'icas-h5.th.kex-express.com',
    'icas-os-h5-uat.sf.global',
    'icas-os-h5.sf.global',
    'icas-h5-id.sit.sf-express.com',
    'icas-h5-id.sf-express.com',
    'icas-h5-uat.th.kex-express.com'
  ],
}

// const hashUrl = [
//   '#/register',
//   '#/login'
// ]

// 判断 当前域名 是不是 移动端的域名
function isCurrentDeviceUrl(type) {
  const currentUrl = window.location.origin
  for (const i in UrlData[type]) {
    if (currentUrl.indexOf(UrlData[type][i]) > -1) {
      return true
    }
  }
  // 否则返回 另一个 type 的 域名
  const _type = type === 'pc' ? 'mobile' : 'pc'
  for (const i in UrlData[_type]) {
    const index = currentUrl.indexOf(UrlData[_type][i])
    if (index > -1) {
      return UrlData[type][i]
    }
  }

  return true
}

function replaceParam(urlString, oldParam, newParam) {
  return urlString.replace(`?${oldParam}=`, `?${newParam}=`).replace(`&${oldParam}=`, `&${newParam}=`)
}

// function replaceUrlParam(url, paramName, newValue) {
//   // 使用正则表达式匹配参数部分
//   const regex = new RegExp(`([?&])${paramName}=.*?(&|$)`, 'i')
//   if (url.search(regex) >= 0) {
//     // 如果参数存在，替换其值
//     return url.replace(regex, `$1${paramName}=${newValue}$2`)
//   }
//   // 如果参数不存在，添加新参数
//   const separator = url.includes('?') ? '&' : '?'
//   return `${url}${separator}${paramName}=${newValue}`
// }

// function getParamValueByRegex(url, paramName) {
//   const regex = new RegExp(`[?&]${paramName}=([^&]*)`)
//   const match = url.match(regex)
//   if (match) {
//     return match[1]
//   }
//   return null
// }

// function replaceLang(url, type) {
//   let lang = getParamValueByRegex(url, 'lang')
//   if (!lang) return url
//   if (type === 'mobile') {
//     lang = lang.replace('-', '_')
//   } else {
//     lang = lang.replace('_', '-')
//   }

//   return replaceUrlParam(url, 'lang', lang)
// }

export const switchCurrentDevice = () => {
  // 判断是 移动端 还是 PC端
  try {
    if (isMobileDevice() && (window.innerWidth <= 768 || document.documentElement.clientWidth <= 768)) {
      console.log('%c Line:60 🥖', 'color:#fca650', '是移动设备')
      const data = isCurrentDeviceUrl('mobile')
      console.log('%c Line:61 🍋 data', 'color:#2eafb0', data)
      if (typeof data === 'string') {
        if (window.location.href.indexOf('#/?') === -1 && window.location.hash !== '#/') return
        let url = ''
        if (window.location.hash === '#/') {
          url = window.location.href.replace(window.location.host, data).replace('#/', '#/login')
        } else {
          url = window.location.href.replace(window.location.host, data).replace('#/?', '#/login?')
        }
        console.log('%c Line:65 🍬 url', 'color:#33a5ff', url)
        // 解决移动端和pc端 ，lang参数不一致的问题
        // url = replaceLang(url, 'mobile')
        window.location.href = replaceParam(url, 'from', 'redirectUrl')
      }
    }
    //  else {
    //   console.log('%c Line:70 🥑', 'color:#42b983', '这是PC端设备')
    //   const data = isCurrentDeviceUrl('pc')
    //   console.log('%c Line:70 🥖 data', 'color:#ffdd4d', data)
    //   if (typeof data === 'string') {
    //     if(window.location.hash === '#/login'){

    //     }
    //     if (window.location.href.indexOf('#/login?') === -1 && window.location.hash !== '#/') return
    //     let url = window.location.href.replace(window.location.host, data).replace('#/login?', '#/?')
    //     console.log('%c Line:74 🎂 url', 'color:#93c0a4', url)
    //     // 解决移动端和pc端 ，lang参数不一致的问题
    //     url = replaceLang(url, 'pc')
    //     window.location.href = replaceParam(url, 'redirectUrl', 'from')
    //   }
    // }
  } catch (error) {
    console.log('%c Line:80 🍪 error', 'color:#465975', error)
    /* empty */
  }
}

function isMobileDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return true
  }

  if (/android/i.test(userAgent) || /Android/i.test(userAgent)) {
    return true
  }

  if (/HarmonyOS/i.test(userAgent)) {
    return true
  }

  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return true
  }

  return false
}
